import type { MainPageStore } from './MainPageStore';

export const defaultState: MainPageStore = {
  casesSummary: null,
  searchText: '',
  statusFilter: 'all',
  showArchived: false,
  casesList: [],
  casesTotal: 0,
  casesSortColumn: 'createdDateTime',
  casesSortOrder: 'desc',
  paginationAmount: 10,
  paginationStart: 1,
};

export const namespace = 'vtn-cbsa-state-mainPage';
